/* eslint-disable camelcase */
import React from 'react';
import { Credit, Subtitle } from './styles';

import 'photoswipe/dist/photoswipe.css';
import normalizeText from '../../utils/normalize-Text';
import getObjectByKey from '../../utils/get-Image-By-Key';

export interface IImage {
  retranca?: string;
  src: string;
  width?: number;
  height?: number;
  tamanho?: string;
  texto_alternativo?: string;
  fonte?: string;
  legenda?: string;
  credito?: string;
  newClassName?: string;
  loading?: 'eager' | 'lazy' | undefined;
}

function Image({
  texto_alternativo,
  retranca,
  src = getObjectByKey(retranca),
  height,
  width,
  loading = 'lazy',
  credito,
  newClassName,
  legenda,
  fonte,
  tamanho = 'grande',
}: IImage) {
  const srcSet = `${src} 1x, ${src} 2x`;

  return (
    <div className={`wrap-image ${normalizeText(tamanho)}`}>
      <img
        src={src}
        loading={loading}
        alt={texto_alternativo}
        srcSet={srcSet}
        className={newClassName}
        width={width}
        height={height}
      />
      {legenda && <Subtitle>{legenda}</Subtitle>}
      {fonte && <Subtitle>{fonte}</Subtitle>}
      {credito && <Credit>{credito}</Credit>}
    </div>
  );
}

export default Image;
